import { useEffect, useState } from "react";

export default function ScoreGauge({ score, color }) {
  const [displayed, setDisplayed] = useState(0);
  const radius = 92;
  const circumference = 2 * Math.PI * radius;
  // Half circle gauge: only top half
  const arcLen = circumference * 0.5;
  const target = Math.max(0, Math.min(100, score));
  const offset = arcLen - (arcLen * displayed) / 100;

  useEffect(() => {
    let raf;
    const start = performance.now();
    const duration = 1200;
    const animate = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplayed(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(animate);
    };
    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [target]);

  return (
    <div className="relative w-[260px] h-[150px]" data-testid="score-gauge">
      <svg viewBox="0 0 240 140" className="w-full h-full">
        <path
          d="M 28 130 A 92 92 0 0 1 212 130"
          stroke="#E2E8F0"
          strokeWidth="14"
          fill="none"
          strokeLinecap="round"
        />
        <path
          d="M 28 130 A 92 92 0 0 1 212 130"
          stroke={color}
          strokeWidth="14"
          fill="none"
          strokeLinecap="round"
          strokeDasharray={`${arcLen} ${circumference}`}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.05s linear" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-end pb-1">
        <div
          data-testid="score-value"
          className="font-display text-6xl sm:text-7xl font-bold tracking-tighter leading-none"
          style={{ color }}
        >
          {displayed}
        </div>
        <div className="text-sm text-slate-500 mt-1">de 100</div>
      </div>
    </div>
  );
}
